export default __webpack_public_path__ + "static/media/telegram-icon-white.93778aaf.svg";